import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

/**
 * Displays a 404 page with an option to navigate home.
 */
const NotFound = () => {
  const navigate = useNavigate();

  /**
   * Redirects the user to the default route ("/") when called.
   */
  const redirectToDefault = () => {
    navigate("/");
  };
  
  return (
    <div className="flex flex-col items-center justify-center h-dvh bg-neutral-100 text-neutral-600">
      <h1 className="mb-4 text-3xl">404 - Page Not Found</h1>
      <Button onClick={redirectToDefault}>Go Home</Button>
    </div>
  );
};

export default NotFound;